import React from "react";
import { MessageSquareText, MonitorPlay, Rocket } from "lucide-react";

const STEPS = [
  { icon: MessageSquareText, title: "Describe it", text: "Type what you want in plain words — “a booking site for my salon” is enough. Pick the AI model that fits the job." },
  { icon: MonitorPlay, title: "Preview & refine in chat", text: "Watch the code being written live, click around the real preview, and ask for changes until it feels right." },
  { icon: Rocket, title: "Publish in one click", text: "Go live on your own Ishukart address, connect a custom domain, download the code or push it to GitHub." },
];

export const HowItWorks = () => (
  <section id="how" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
    <div className="grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <span className="text-xs font-mono uppercase tracking-wider text-emerald-600">How it works</span>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">From a sentence to a live app.</h2>
        <p className="mt-4 text-slate-500 leading-relaxed">No setup, no code required. Every step stays editable — you are always one message away from the next version.</p>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-3 gap-4">
        {STEPS.map((s, i) => (
          <div key={s.title} className="relative rounded-2xl border border-slate-200/80 bg-white p-6 hover:border-sky-300 transition-colors" data-testid={`how-step-${i + 1}`}>
            <span className="absolute top-5 right-5 font-mono text-xs text-slate-400">0{i + 1}</span>
            <span className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-600 flex items-center justify-center"><s.icon size={18} /></span>
            <h3 className="mt-5 text-lg font-semibold text-slate-900">{s.title}</h3>
            <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
